var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPendingLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,1c-2.872,0-5.68,0.502-8.348,1.492l0.696,1.875C19.792,3.46,22.367,3,25,3c12.131,0,22,9.869,22,22s-9.869,22-22,22 S3,37.131,3,25c0-6.595,2.963-12.795,8-16.958V15h2V5H3v2h6.126C3.993,11.53,1,18.068,1,25c0,13.233,10.767,24,24,24 s24-10.767,24-24S38.233,1,25,1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,33h-2v2h16v-2h-2v-3.414L26.414,25L31,20.414V17h2v-2H17v2h2v3.414L23.586,25L19,29.586V33z M21,19.586V17h8v2.586 l-4,4L21,19.586z M25,26.414l4,4V33h-8v-2.586L25,26.414z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 39,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 39,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 39,
    width: 2,
    height: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingLogo);
export default __webpack_public_path__ + "static/media/pendingLogo.7627538791e9377350a9327f0d5dadd7.svg";
export { ForwardRef as ReactComponent };